export default __webpack_public_path__ + "static/media/bookIcon.6af9a7f9.svg";